import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import LinkOffIcon from "@material-ui/icons/LinkOff";

import axios from "axios";
import ConfirmationModal from "views/components/ConfirmationModal";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { pinCodeData } from "assets/properties/properties";
import { toastAction } from "assets/properties/properties";

const Pincodes = (props) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [templateData, setTemplateData] = useState(["PinCodes"]);
  const [rawData, setRawData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deletePincodeId, setDeletePincodeId] = useState("");
  const [unlinkPincodeId, setUnlinkPincodeId] = useState({});
  const [confirmationUnlinkModal, setConfirmationUnlinkModal] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const handlegoldrateSubmit = async () => {
    navigate(pinCodeData?.createUrl);
  };

  // get pincode api calling
  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_PINCODE_FIND,
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate(toastAction?.error, result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };

  // parseindiadata function
  const parseIndicatorData = (data) => {
    let reportData = [];
    let downloadData = [];
    downloadData.push(templateData);
    data.forEach((pin, i) => {
      let row = {
        pincode: pin.pincode,
        branchname: pin.branchName,
        action: getIcons(pin.pincode, pin.branchCode),
      };
      reportData.push(row);
      downloadData.push(pin);
    });
    setSelectedTableData(reportData);
  };
  // icons function calling
  const getIcons = (pincode, branchCode) => {
    return (
      <>
        <IconButton
          aria-label="Delete Pincode"
          onClick={() => onClickDeleteData(pincode)}
        >
          <DeleteIcon />
        </IconButton>
        <IconButton
          aria-label="De-Link Pincode"
          onClick={() => onClickUnlinkData(pincode, branchCode)}
        >
          <LinkOffIcon />
        </IconButton>
      </>
    );
  };
  const onClickUnlinkData = (pincode, branchCode) => {
    setConfirmationModalHeader(pinCodeData?.unlinkConfirmationHeader);
    setConfirmationModalMsg(pinCodeData?.confirmationMsg);
    setUnlinkPincodeId({ pincode, branchCode });
    setConfirmationUnlinkModal(true);
  };
  const handleNegativeUnlinkResponse = () => {
    setConfirmationUnlinkModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setUnlinkPincodeId({});
  };
  const handlePositiveUnlinkResponse = async () => {
    const pin = unlinkPincodeId;
    handleNegativeUnlinkResponse();
    if(pin.branchCode === "" || pin.branchCode === null){
      toastUpdate(toastAction?.error, pinCodeData?.notLinked, true);
    }else{
    // Call API to delete Pincode
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_PINCODE_DELINK,
      method: "POST",
      authToken: authToken,
      data: {
        pincodes: [pin.pincode],
        hierarchyCode: pin.branchCode,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate(toastAction?.error, res?.data?.user_description, true);
    } else {
      toastUpdate(toastAction?.success, pinCodeData?.unlinkedSuccess, true);
      GetData();
    }
  }
  };
  // download

  // delete function
  const onClickDeleteData = (pincode) => {
    setConfirmationModalHeader(pinCodeData?.label);
    setConfirmationModalMsg(pinCodeData?.delConfirmationMsg);
    setDeletePincodeId(pincode);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeletePincodeId("");
  };
  const handlePositiveResponse = async () => {
    const PincodeId = deletePincodeId;
    handleNegativeResponse();
    const URL =
      endpoint.BASE_URL_STAGING + "/" + endpoint.MASTER_PINCODE_DELETE;
    const res = await axios.delete(URL, {
      headers: {
        Authorization: "Bearer " + authToken,
      },
      data: {
        pincodes: [PincodeId],
      },
    });
    if (res?.data?.error_code) {
      toastUpdate(toastAction?.error, res?.data?.user_description, true);
    } else {
      toastUpdate(toastAction?.success, pinCodeData?.delSuccess, true);
      GetData();
    }
  };

  // serach function calling
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        row.pincode.toLowerCase().includes(val.toLowerCase()) ||
        (row.branchName &&
          row.branchName.toLowerCase().includes(val.toLowerCase()))
      );
    });
    parseIndicatorData(filteredData);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label={pinCodeData?.label}
          button1={pinCodeData?.button}
          button1click={handlegoldrateSubmit}
          onSearchChange={onSearchChange}
          searchLabel={pinCodeData?.searchLabel}
          search
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={pinCodeData?.tableColumns} rows={selectedTableData} />
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
      <ConfirmationModal
        confirmationModal={confirmationUnlinkModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeUnlinkResponse}
        handlePositiveButton={handlePositiveUnlinkResponse}
      />
    </GridContainer>
  );
};

Pincodes.propTypes = {
  classes: PropTypes.object,
};

export default Pincodes;
